import { useEffect } from 'react';
import { useLocation, useNavigation } from 'react-router-dom';


export function RouteLogger() {
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === 'idle') {
      // noop - route change logged by effect dependency
    }
  }, [location, navigation]);

  return null;
}
